<div id="portal-sidebar">
  <div class="sidebar-wrapper am-flex-column pt-m pb-m p-s-mobile bg-white height-full" [ngClass]="sidebarMinified ? 'width-75' : 'width-340 pl-m pr-m'">
    <div class="am-flex-column am-flex-1 height-full overflow-x hide-scrollbar">
      @for (navItem of mainNavItems; track navItem.identifier) {
        <sidebar-item class="am-flex-column text-m"
                     [class.bb-table-grey-2]="$index+1 !== mainNavItems.length"
                     [ngClass]="sidebarMinified ? 'ml-xs mr-xs' : ''"

                     [item]="navItem"
                     [activeTab]="activeTab"
                     [sidebarMinified]="sidebarMinified"
                     [getReportsCount]="getReportsCountFn"

                     (callback)="changeDashboard($event)">
        </sidebar-item>
      }
    </div>

    <div class="am-flex-column gap-xs mta text-s" [ngClass]="sidebarMinified ? 'am-flex-align ml-xs mr-xs' : 'p-xxs'">
      @if (user.isCustomer && user.preferences) {
        <sidebar-user-preferences-toggler [class.minimised]="sidebarMinified"
                                          [currentUser]="user"
                                          [collapsePreview]="collapsePreview"
                                          [sidebarMinified]="sidebarMinified"
                                          (toggleSidebar)="toggleSidebar()">
        </sidebar-user-preferences-toggler>
      }
      @if (debugMode) { <span class="am-flex-align width-full hover-active" [routerLink]="['/time-tracking/debug']">Debug</span> }
      @for (navItem of botomNavItems; track navItem) {
        <span class="am-flex-align width-full hover-active relative" [class.am-flex-justify-center]="sidebarMinified" (click)="changeDashboard(navItem)">
          @if ( sidebarMinified) { <span class="am-flex-center font-icon" [ngClass]="navItem.icon"></span> }
          @if (!sidebarMinified) { <span>{{ navItem.title }}</span> }
          @if (navItem.dot     ) { <span class="absolute right-0 mr-xxs circle-xs bg-orange"></span> }
        </span>
      }
      <span class="am-flex-align width-full gap-xs mt-xxs color-disabled" [class.am-flex-justify-center]="sidebarMinified" (click)="openDebug()">
        @if (!sidebarMinified) { <span>Version</span> }
        <span class="am-flex-align gap-xxs" [class.am-flex-column]="sidebarMinified">
          <span>{{ version }}</span>
          @if (buildHash) { <span [class.display-none]="sidebarMinified">|</span> }
          @if (buildHash) { <span>{{ buildHash }}</span> }
        </span>
      </span>
    </div>
  </div>
  <div class="sidebar-overflow" toggleSidebar></div>
</div>
